import React, { useState } from "react"
import SanityImage from "gatsby-plugin-sanity-image"

const HoverCard = ({ className = "", image, children }) => {
  const [isOpen, setIsOpen] = useState(false)

  const open = () => {
    setIsOpen(true)
  }

  const close = () => {
    setIsOpen(false)
  }

  return (
    <span
      className={`hover-card ${isOpen ? "hover-card--open" : ""} ${className}`}
      tabIndex={0}
      onFocus={open}
      onBlur={close}
      onMouseEnter={open}
      onMouseLeave={close}
    >
      <span className="hover-card__dotted-underline">{children}</span>

      {isOpen && (
        <div class="hover-card__image">
          <SanityImage {...image} alt="" role="presentation" />
        </div>
      )}
    </span>
  )
}

export default HoverCard
